import { render, staticRenderFns } from "./CarrierDetail.vue?vue&type=template&id=48a0ca98&scoped=true&"
import script from "./CarrierDetail.vue?vue&type=script&lang=js&"
export * from "./CarrierDetail.vue?vue&type=script&lang=js&"
import style0 from "./CarrierDetail.vue?vue&type=style&index=0&id=48a0ca98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a0ca98",
  null
  
)

export default component.exports